import React, { useRef, useState } from 'react';
import { Button, Popup } from '@ui';
/**
 * Invoice's single bulk action, rendered by the shared `AttachmentsToolbar` before its Delete
 * button. Presentational: it owns only its popover's open/closed UI state and calls back up to
 * `useAttachmentBulkEdits`'s mutation handler.
 *
 * An action list rather than Building's checkboxes, because `file_access` is one value out of two,
 * not independent flags — a checkbox would imply the two can be combined.
 */
export function InvoiceAttachmentsBulkActions({ updateVisibilityLabel, fileAccessOptions, disabled, onUpdateFileAccess }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const buttonRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: buttonRef, isMenu: true, disabled: disabled, onClick: () => setIsMenuOpen((prev) => !prev) },
            React.createElement("i", { className: "fa-light fa-eye", "aria-hidden": "true" }),
            " ",
            updateVisibilityLabel),
        React.createElement(Popup, { anchor: buttonRef.current, show: isMenuOpen, onClose: () => setIsMenuOpen(false), position: "bottom-left", containerClass: "qmb-ui-popup--action-list attachments-toolbar__visibility-menu" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, { padded: true }, fileAccessOptions.map((option) => (React.createElement(Button, { key: option.value, type: "button", onClick: () => {
                        setIsMenuOpen(false);
                        onUpdateFileAccess(option.value);
                    } }, option.label))))))));
}
